import React, { Component } from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
}
export function CTAButton({
  children,
  onClick,
  href,
  className = ''
}: CTAButtonProps) {
  const Component = href ? motion.a : motion.button;
  return <Component href={href} target={href ? '_blank' : undefined} rel={href ? 'noopener noreferrer' : undefined} onClick={onClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        relative overflow-hidden group inline-block text-center
        bg-brand-yellow text-brand-brown font-bold uppercase tracking-wide
        px-8 py-4 rounded-full shadow-lg hover:shadow-xl
        transition-all duration-300 ease-out no-underline
        ${className}
      `} data-id="element-170">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-171">
        {children}
      </span>
      {/* Subtle pulse/glow effect */}
      <div className="absolute inset-0 rounded-full ring-4 ring-brand-yellow/30 animate-pulse-slow" data-id="element-172"></div>
      <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-full" data-id="element-173"></div>
    </Component>;
}